import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../store/slices/authSlice';
import { generateTraceId, logUserAction } from '../../utils/trace';
import TenantSwitcher from '../auth/TenantSwitcher';

function Navbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const handleLogout = async () => {
    const traceId = generateTraceId();
    logUserAction(traceId, 'logout');
    await dispatch(logout({ traceId }));
    navigate('/login');
  };

  return (
    <nav className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center gap-4">
            <h1 className="text-xl font-bold text-gray-900">Job Platform</h1>
            <TenantSwitcher />
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-600" data-testid="navbar-user-email">{user?.email}</span>
            {user?.isGodMode && (
              <span className="inline-block bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs font-medium" data-testid="navbar-god-mode-badge">
                God Mode
              </span>
            )}
            <button
              onClick={handleLogout}
              className="text-sm text-gray-600 hover:text-gray-900 underline"
              data-testid="navbar-logout-button"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
